var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-form" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": "",
            width: "1000px",
            "custom-class": "custom-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("关 闭")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _vm.productInfo.productId
                ? _c(
                    "div",
                    { staticClass: "ml40" },
                    [
                      _c(
                        "div",
                        { staticClass: "goods-info mb16" },
                        [
                          _c("el-image", {
                            staticClass: "goods-img",
                            attrs: {
                              src: _vm.productInfo.productImage,
                              "preview-src-list": [
                                _vm.productInfo.productImage,
                              ],
                            },
                          }),
                          _c("div", { staticClass: "info-content ml20" }, [
                            _c("div", { staticClass: "info-title" }, [
                              _vm._v("("),
                              _c("span", { staticClass: "text-highlight" }, [
                                _vm._v(_vm._s(_vm.productInfo.productId)),
                              ]),
                              _vm._v(
                                ") " + _vm._s(_vm.productInfo.productName)
                              ),
                            ]),
                            _c("div", { staticClass: "info-text mt15" }, [
                              _vm._v("SKU：" + _vm._s(_vm.productInfo.skuName)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "row-box", attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "label-text" }, [
                              _vm._v("商户名称："),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.productInfo.merchantName)),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "label-text" }, [
                              _vm._v("商品品牌："),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.productInfo.brandName)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "row-box", attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "label-text" }, [
                              _vm._v("商品成本价："),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.productInfo.cost) + " 元"),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("span", { staticClass: "label-text" }, [
                              _vm._v("商城售价："),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.productInfo.price) + " 元"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "pt20" },
                [
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("监控商品竞品列表"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "ml40" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:competitor:add"],
                              expression: "['platform:competitor:add']",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openForm("create")
                            },
                          },
                        },
                        [_vm._v(" 新增竞品 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mt14 table-fixed-scroll-overflow" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "tableRef",
                          attrs: {
                            data: _vm.tableData,
                            size: "small",
                            height: "calc(100vh - 600px)",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "序号",
                              type: "index",
                              width: "50",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "platform",
                              label: "竞品平台",
                              "min-width": "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.findLabelInArray(
                                            _vm.platformIdsOptions,
                                            scope.row.platform
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "商品名称",
                              "min-width": "180",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "demo-image__preview line-heightOne mr10",
                                          },
                                          [
                                            !scope.row.productImage
                                              ? _c("el-image", {
                                                  attrs: {
                                                    src: _vm.coverImage,
                                                  },
                                                })
                                              : _c("el-image", {
                                                  staticClass: "product-image",
                                                  attrs: {
                                                    src: scope.row.productImage,
                                                    "preview-src-list": [
                                                      scope.row.productImage,
                                                    ],
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-overflow" },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.productName)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "specName",
                              label: "规格名称",
                              "min-width": "120",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "productCode",
                              label: "商品编码",
                              "min-width": "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuCode",
                              label: "SKU 编码",
                              "min-width": "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "crawlerPrice",
                              label: "商品价格",
                              width: "100",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "url",
                              label: "商品 URL",
                              "min-width": "180",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: scope.row.url,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.url))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shopName",
                              label: "店铺名称",
                              "min-width": "180",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "aiScore",
                              label: "AI智能推荐",
                              width: "100",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "aiScoreReason",
                              label: "AI推荐理由",
                              "min-width": "120",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "addTime",
                              label: "添加时间",
                              width: "140",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "source",
                              label: "来源",
                              width: "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.findLabelInArray(
                                            _vm.sourceOptions,
                                            scope.row.source
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "isAssociated",
                              label: "是否关联",
                              width: "80",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-switch", {
                                      staticStyle: { width: "45px !important" },
                                      attrs: {
                                        value: scope.row.isAssociated,
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        disabled: !_vm.checkPermi([
                                          "platform:competitor:edit",
                                        ]),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleRelatedChange(
                                            scope.row,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "90",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.canEdit
                                      ? _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "platform:competitor:edit",
                                                ],
                                                expression:
                                                  "['platform:competitor:edit']",
                                              },
                                            ],
                                            staticClass: "mr10",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openForm(
                                                  "update",
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("编辑")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "platform:competitor:delete",
                                            ],
                                            expression:
                                              "['platform:competitor:delete']",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlerOpenDel(
                                              scope.row.id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("CompetitionProductInfoForm", {
        ref: "formRef",
        on: { success: _vm.getDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }